// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k0f7","textarea":"styles_textarea__1jVQU"};